import React from 'react'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import { MyEvent } from '../../../../types'
import { formatName, fromNow } from '../../../../common'
import { HeadPost, Postcontent } from '../../../SocialPanel/style'
import { SmsPreviewContainer } from '../../../SocialPanel/components/style'
import { MainEventImage } from '../../../../components/Avatar'
import { salmon } from '../../../../styles/themeColors'

export const PostSMSPreview: React.FC<{
  event: MyEvent
  className?: string
}> = ({ event, className = '' }) => {
  const partnerNames = [
    formatName(event.brideFirstName),
    formatName(event.groomFirstName),
  ]
    .filter(Boolean)
    .join(' and ')

  const samplePostText =
    'Welcome to our special day! We are so excited to celebrate with you all.'

  const sampleSMSText = (
    <>
      {partnerNames}: {samplePostText}
      <br />
      https://ktell.io/xpsmpw
    </>
  )

  if (!partnerNames) {
    return (
      <div className={className}>
        <p className="text-muted fz-14 text-center p-4">
          The couple's names have not been set for this event
        </p>
      </div>
    )
  }

  return (
    <div className={className}>
      <p className="text-muted fz-14 text-center mb-3 mb-md-5">
        This is how posts and SMS messages will appear when created by K&T
        members on behalf of the couple
      </p>

      <Row>
        <Col xs={12} lg={6} className="mb-4">
          <h4 className="fz-16 fwsb mb-3">Post Preview</h4>
          <Card className="shadow-sm rounded mb-2 feed-post">
            <Card.Body className="p-2 p-md-3">
              <HeadPost>
                <MainEventImage
                  eventId={event.id}
                  className="rounded-circle"
                  size="40x40"
                  defaultSize={48}
                  defaultColor={salmon}
                />
                <div className="info">
                  <h5 className="mb-0 fz-16">{partnerNames}</h5>
                  <small className="text-muted">
                    {fromNow(new Date().toISOString())}
                  </small>
                </div>
              </HeadPost>
              <Postcontent className="mb-1 pb-3 pt-1 px-1">
                {samplePostText}
              </Postcontent>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={6} className="mb-4">
          <h4 className="fz-16 fwsb mb-3">SMS Preview</h4>
          <p className="tc-lgray fz-12 mb-2">
            Preview shown is an estimate based on common device settings
          </p>
          <SmsPreviewContainer>
            <div className="sms-box">{sampleSMSText}</div>
          </SmsPreviewContainer>
        </Col>
      </Row>
    </div>
  )
}
